export const demo_SceneGraph_Particulation_ImageBoxes = [
  {
    id: "particulation-main",
    label: "Particulation Experiment",
    type: "ImageBox",
    description: "Main particulation visualization showing particle dynamics",
    imageUrl: "/images/demo/experiment/particulation.png",
    topLeft: {
      x: 50,
      y: 50,
    },
    bottomRight: {
      x: 750,
      y: 550,
    },
  },
  {
    id: "particle-cluster-1",
    label: "Primary Particle Cluster",
    type: "ImageBox",
    description: "Dense cluster of particles showing gravitational attraction",
    imageUrl: "/images/demo/experiment/particulation.png",
    topLeft: {
      x: 200,
      y: 150,
    },
    bottomRight: {
      x: 350,
      y: 300,
    },
  },
  {
    id: "particle-cluster-2",
    label: "Secondary Particle Cluster",
    type: "ImageBox",
    description: "Secondary cluster with different particle density",
    imageUrl: "/images/demo/experiment/particulation.png",
    topLeft: {
      x: 450,
      y: 200,
    },
    bottomRight: {
      x: 600,
      y: 350,
    },
  },
  {
    id: "particle-trajectory",
    label: "Particle Trajectory",
    type: "ImageBox",
    description: "Path showing particle movement and interaction",
    imageUrl: "/images/demo/experiment/particulation.png",
    topLeft: {
      x: 300,
      y: 400,
    },
    bottomRight: {
      x: 500,
      y: 480,
    },
  },
  {
    id: "boundary-zone",
    label: "Boundary Zone",
    type: "ImageBox",
    description: "Edge region showing particle behavior at boundaries",
    imageUrl: "/images/demo/experiment/particulation.png",
    topLeft: {
      x: 100,
      y: 100,
    },
    bottomRight: {
      x: 150,
      y: 500,
    },
  },
];
